export function toggle(menu: HTMLElement): void {
  menu.classList.toggle("hidden");
}
